import { useShell } from '../../layout'
import { Box, CenteredBox } from '../../widgets'
import { AnalyticsData, Compare, useAnalyticsData, YourData } from '../../analytics'
import './Analytics.scss'
import { usePracticeWheel } from '../common/index.js'

export const Analytics = ({ active }) => {
  useShell({ active, mode: 'logo' })

  usePracticeWheel().hide()

  return (
    <CenteredBox
      container
      column
      fullWidth
      fullHeight
      py={120}
      className="display-analytics"
    >
      <Box column fullWidth fullHeight alignItems="center">
        <AnalyticsData displayMode>
          <Wrapper />
        </AnalyticsData>
      </Box>
    </CenteredBox>
  )
}

const Wrapper = () => {
  const { mode } = useAnalyticsData()

  return mode === 'compare' ? <Compare displayMode /> : <YourData displayMode />
}